<ng-content select="cs-icon[leading]"></ng-content>
<div class="select-label">
  {{getLabel() || placeholder}}
</div>
@if (!disabled) {
  <cs-icon name="arrow-dropdown" class="dropdown-icon"></cs-icon>
}
<!-- a button that opens a list, and says whether that list is open -->
<button [disabled]="disabled" cs-capture-cover (click)="handleSelectClick($event)"
[attr.aria-label]="ariaLabel || null" aria-haspopup="listbox"
[attr.aria-expanded]="popoverOpen ? 'true' : 'false'"></button>
